import { StoreAction } from "../../@core/constants";

const initialState = {
  projectList: [],
  projectTaskList: [],
  kanbanProjectTask: [],
  allProjectTaskList: {},
  selectedTask: {},
  selectedProject: {},
  pagination: {},
  projectCount: 0,
  projectFilter: {},
  allProjectList: [],
  allSortingFiltersList: {},
  projectTaskClickedFromNotification: 0,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case StoreAction.GET_PROJECT_LIST:
      return { ...state, projectList: action.payload };
    case StoreAction.GET_PROJECT_TASK_LIST:
      return { ...state, projectTaskList: action.payload };
    case StoreAction.SET_KANBAN_PROJECT_TASK_DATA:
      return { ...state, kanbanProjectTask: action.payload };
    case StoreAction.SET_ALL_PROJECT_TASK_IN_KANBAN:
      return { ...state, allProjectTaskList: action.payload };
    case StoreAction.SET_SELECTED_TASK:
      return { ...state, selectedTask: action.payload };
    case StoreAction.SET_SELECTED_PROJECT:
      return { ...state, selectedProject: action.payload };
    case StoreAction.SET_PAGINATION_VALUE:
      return { ...state, pagination: action.payload };
    case StoreAction.SET_PROJECT_COUNT:
      return { ...state, projectCount: action.payload };
    case StoreAction.SET_PROJECT_FILTER:
      return { ...state, projectFilter: action.payload };
    case StoreAction.SET_ALL_PROJECT_LIST:
      return { ...state, allProjectList: action.payload };
    case StoreAction.PROJECT_TASK_CLICKED_FROM_NOTIFICATION:
      return { ...state, projectTaskClickedFromNotification: action.payload };
    case StoreAction.SET_ALL_SORTING_FILTERS_LIST:
      return { ...state, allSortingFiltersList: action.payload };
    default:
      return state;
  }
}
